export default "__VITE_PUBLIC_ASSET__1526979c__"